import {
    RECEIVE_CURRENT_USER,
    RECEIVE_USER_LOGOUT,
    RECEIVE_USER_SIGN_IN,
    RECEIVE_TOKEN_DATA,
    RECEIVE_ADDITIONAL_SETTINGS
} from "../actions/sessionActions";

const initialState = {
  isAuthenticated: false,
  user: {},
  tokenData:null,
  additionalSettings: []
};

const SessionReducer = (state = initialState, action) => {
  switch (action.type) {
    case RECEIVE_CURRENT_USER:
      return {
        ...state,
        isAuthenticated: !!action.currentUser,
        user: action.currentUser,
      };
    case RECEIVE_USER_LOGOUT:
      return {
        isAuthenticated: false,
        user: undefined,
      };
    case RECEIVE_USER_SIGN_IN:
      return {
        ...state,
        isSignedIn: true,
      };
    case RECEIVE_TOKEN_DATA:
      return {
        ...state,
         tokenData:action.tokenArray
      };
    case RECEIVE_ADDITIONAL_SETTINGS:
      return {
        ...state,
        additionalSettings: action.additionalSettings
      };
    default:
      return state;
  }
}

export default SessionReducer;
